import { withExceptionCatcher } from '@/components/hoc/with-exception-catcher';
import NewsArchive from '@/components/pages/news-archive/layout/news-archive-page';
import { NewsArchiveProvider } from '@/context/news-archive-ctx';
import { ArticleType } from '@/types/article-type';
import type { Category } from '@/utils/functions/wordpress/fetch-categories';

export interface NewsArchiveControllerProps {
    readMoreArticles: ArticleType[];
    categories: Category[];
    tags: Category[];
    authors: Category[];
}

export const NewsArchiveController = ({ readMoreArticles, categories, tags, authors }: NewsArchiveControllerProps) => {
    return (
        <NewsArchiveProvider>
            <NewsArchive articles={readMoreArticles} categories={categories} tags={tags} authors={authors} />
        </NewsArchiveProvider>
    );
};

export default withExceptionCatcher(NewsArchiveController);
